import React, { useState, useEffect, useMemo } from 'react';

const ActionItems = ({ 
  position = 'button', // Where to display: 'button' (next to fight back) or 'popup'
  className = '' 
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [actionItems, setActionItems] = useState([]);
  // DON'T EDIT ANYTHING ABOVE!
  // EDIT THIS PART !!
  const actionItemsConfig = useMemo(() => [
    {
      id: 'testify-march-2025',
      title: 'Make a public comment against vouchers!',
      description: 'The Texas House has asked for public comment on the voucher bill in the House of Representatives before Tuesday, March 11 — will you defend your neighborhood schools and testify against the voucher scam?',
      ctaText: 'Testify against vouchers online',
      ctaLink: '/testify', // Uses the redirect in App.js
      startDate: new Date('2025-02-01T00:00:00'),
      endDate: new Date('2025-03-12T00:00:00'), // Will disappear on March 12
      position: ['button', 'popup'] // Show in both positions
    }
  ], []);

  // Filter active action items based on current date and requested position
  useEffect(() => {
    const now = new Date();
    const active = actionItemsConfig.filter(item => {
      return (
        item.position.includes(position) && 
        now >= item.startDate && 
        now < item.endDate
      );
    });
    setActionItems(active);
    
    // Show popup after a short delay if we have popup items
    if (position === 'popup' && active.length > 0) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 3000); // Show popup 3 seconds after component mounts
      
      return () => clearTimeout(timer);
    }
  }, [position, actionItemsConfig]);

  // For tracking clicks
  const trackActionClick = (item) => {
    if (window.gtag) {
      window.gtag('event', 'action_item_click', {
        event_category: 'ActionItems',
        event_label: item.title,
        value: 1,
        action_id: item.id
      });
    }
  };

  // Close popup
  const handleClosePopup = () => {
    setShowPopup(false);
    
    // Set a cookie to prevent showing the popup again in this session
    document.cookie = "actionPopupClosed=true; path=/; max-age=60"; // 1 min lol
  };

  // Check if we should show popup (not if they've closed it before)
  const shouldShowPopup = () => {
    return showPopup && !document.cookie.includes('actionPopupClosed=true');
  };

  // Render action buttons (to show next to "How do I fight back?")
  if (position === 'button' && actionItems.length > 0) {
    return (
      <div className={`action-buttons ${className}`}>
        {actionItems.map(item => (
          <a 
            key={item.id}
            href={item.ctaLink} 
            className="tel-button action-button"
            onClick={() => trackActionClick(item)}
          >
            {item.ctaText}
          </a>
        ))}
      </div>
    );
  }
  
  // Render popup
  if (position === 'popup' && shouldShowPopup() && actionItems.length > 0) {
    // Use first action item for popup content
    const popupItem = actionItems[0];
    
    return (
      <div className="action-popup-overlay">
        <div className="action-popup">
          <button className="action-popup-close" onClick={handleClosePopup}>×</button>
          <h2>{popupItem.title}</h2>
          <p>{popupItem.description}</p>
          <a 
            href={popupItem.ctaLink} 
            className="tel-button"
            onClick={() => trackActionClick(popupItem)}
          >
            {popupItem.ctaText}
          </a>
        </div>
      </div>
    );
  }
  
  // Return null if no active items or popup is closed
  return null;
};

export default ActionItems;
